import React from "react";

const stroke = "currentColor";

export const IconDashboard = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden>
    <path d="M4 4H10V10H4V4ZM14 4H20V10H14V4ZM4 14H10V20H4V14ZM14 14H20V20H14V14Z" stroke={stroke} strokeWidth="1.6" />
  </svg>
);

export const IconReviews = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden>
    <path
      d="M8 10H16M8 14H12"
      stroke={stroke}
      strokeWidth="1.6"
      strokeLinecap="round"
    />
    <path
      d="M6 18L7.5 14H18C19.1046 14 20 13.1046 20 12V8C20 6.89543 19.1046 6 18 6H6C4.89543 6 4 6.89543 4 8V18H6Z"
      stroke={stroke}
      strokeWidth="1.6"
      strokeLinejoin="round"
    />
    <path
      d="M15 8L17 6"
      stroke={stroke}
      strokeWidth="1.6"
      strokeLinecap="round"
    />
  </svg>
);

export const IconBilling = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden>
    <rect x="3" y="6" width="18" height="12" rx="2" stroke={stroke} strokeWidth="1.6" />
    <path d="M3 10H21" stroke={stroke} strokeWidth="1.6" />
    <path d="M7 15H11" stroke={stroke} strokeWidth="1.6" strokeLinecap="round" />
  </svg>
);

export const IconInbox = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden>
    <path
      d="M4 6H20V18H4V6Z"
      stroke={stroke}
      strokeWidth="1.6"
      strokeLinejoin="round"
    />
    <path
      d="M4 10H8L10 12H14L16 10H20"
      stroke={stroke}
      strokeWidth="1.6"
      strokeLinejoin="round"
    />
  </svg>
);

export const IconAttention = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden>
    <path
      d="M12 9V13M12 17H12.01"
      stroke={stroke}
      strokeWidth="1.8"
      strokeLinecap="round"
    />
    <path
      d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0Z"
      stroke={stroke}
      strokeWidth="1.6"
      strokeLinejoin="round"
    />
  </svg>
);

export const IconDeletionCases = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden>
    <path
      d="M9 5H15L17 8H19C19.5523 8 20 8.44772 20 9V19C20 19.5523 19.5523 20 19 20H5C4.44772 20 4 19.5523 4 19V9C4 8.44772 4.44772 8 5 8H7L9 5Z"
      stroke={stroke}
      strokeWidth="1.6"
      strokeLinejoin="round"
    />
    <path d="M12 11V15" stroke={stroke} strokeWidth="1.6" strokeLinecap="round" />
  </svg>
);

export const IconEmailAlerts = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden>
    <path
      d="M4 7L12 13L20 7"
      stroke={stroke}
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <rect x="3" y="5" width="18" height="14" rx="2" stroke={stroke} strokeWidth="1.6" />
  </svg>
);

export const IconPlatforms = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden>
    <circle cx="12" cy="12" r="2.5" fill={stroke} />
    <circle cx="6" cy="8" r="2" stroke={stroke} strokeWidth="1.4" />
    <circle cx="18" cy="8" r="2" stroke={stroke} strokeWidth="1.4" />
    <circle cx="7" cy="17" r="2" stroke={stroke} strokeWidth="1.4" />
    <circle cx="17" cy="17" r="2" stroke={stroke} strokeWidth="1.4" />
    <path d="M7.6 9.4L10.5 11M16.4 9.4L13.5 11M8.8 16L11.2 13.8M15.2 16L12.8 13.8" stroke={stroke} strokeWidth="1.2" />
  </svg>
);

export const IconTeam = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden>
    <circle cx="9" cy="8" r="3.2" stroke={stroke} strokeWidth="1.6" />
    <path
      d="M3.5 19a5.5 5.5 0 0 1 11 0"
      stroke={stroke}
      strokeWidth="1.6"
      strokeLinecap="round"
    />
    <path
      d="M16.5 6.4a3 3 0 0 1 0 5.6M17.5 19a5.4 5.4 0 0 0-2.2-4.3"
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

export const IconPayment = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden>
    <rect x="2" y="5" width="20" height="14" rx="2" stroke={stroke} strokeWidth="1.6" />
    <path d="M2 10H22" stroke={stroke} strokeWidth="1.6" />
    <path d="M6 15H10" stroke={stroke} strokeWidth="1.6" strokeLinecap="round" />
  </svg>
);

export const IconSettings = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden>
    <path
      d="M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"
      stroke={stroke}
      strokeWidth="1.5"
    />
    <path
      d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09a1.65 1.65 0 0 0-1-1.51 1.65 1.65 0 0 0-1.82-.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"
      stroke={stroke}
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const IconSupport = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden>
    <circle cx="12" cy="12" r="9" stroke={stroke} strokeWidth="1.6" />
    <path
      d="M12 16.5V16M12 13.2C12 11.85 13.35 11.7 13.8 10.8C14.1 10.2 13.95 9.45 13.5 9C13.05 8.55 12.3 8.4 11.7 8.55C10.95 8.75 10.35 9.45 10.35 10.5"
      stroke={stroke}
      strokeWidth="1.6"
      strokeLinecap="round"
    />
  </svg>
);

export const IconDocumentation = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden>
    <path
      d="M8 4H16C17.1046 4 18 4.89543 18 6V20C18 21.1046 17.1046 22 16 22H8C6.89543 22 6 21.1046 6 20V6C6 4.89543 6.89543 4 8 4Z"
      stroke={stroke}
      strokeWidth="1.6"
    />
    <path d="M9 9H15M9 13H15M9 17H12" stroke={stroke} strokeWidth="1.6" strokeLinecap="round" />
  </svg>
);

export const IconLogout = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden>
    <path
      d="M9 21H5C4.44772 21 4 20.5523 4 20V4C4 3.44772 4.44772 3 5 3H9"
      stroke={stroke}
      strokeWidth="1.6"
      strokeLinecap="round"
    />
    <path
      d="M16 17L21 12L16 7"
      stroke={stroke}
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21 12H9"
      stroke={stroke}
      strokeWidth="1.6"
      strokeLinecap="round"
    />
  </svg>
);

export const IconUsers = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden>
    <circle cx="9" cy="8" r="3" stroke={stroke} strokeWidth="1.6" />
    <path
      d="M3 20V19C3 16.7909 4.79086 15 7 15H11C13.2091 15 15 16.7909 15 19V20"
      stroke={stroke}
      strokeWidth="1.6"
      strokeLinecap="round"
    />
    <path
      d="M17 11V10C17 8.89543 17.8954 8 19 8"
      stroke={stroke}
      strokeWidth="1.6"
      strokeLinecap="round"
    />
    <circle cx="17" cy="7" r="2.5" stroke={stroke} strokeWidth="1.6" />
  </svg>
);

export const IconOffer = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden>
    <path
      d="M4 8.5V6a2 2 0 012-2h12a2 2 0 012 2v2.5a2 2 0 100 4V18a2 2 0 01-2 2H6a2 2 0 01-2-2v-5.5a2 2 0 100-4z"
      stroke={stroke}
      strokeWidth="1.6"
      strokeLinejoin="round"
    />
    <path d="M9 9.5l6 5M15 9.5l-6 5" stroke={stroke} strokeWidth="1.6" strokeLinecap="round" />
  </svg>
);

export const IconPerks = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden>
    <path
      d="M12 3L14.2 5.3H18.7V9.8L21 12L18.7 14.2V18.7H14.2L12 21L9.8 18.7H5.3V14.2L3 12L5.3 9.8V5.3H9.8L12 3Z"
      stroke={stroke}
      strokeWidth="1.6"
      strokeLinejoin="round"
    />
    <path d="M9.6 14.4L14.4 9.6" stroke={stroke} strokeWidth="1.6" strokeLinecap="round" />
    <circle cx="9.9" cy="9.9" r="0.9" fill="currentColor" />
    <circle cx="14.1" cy="14.1" r="0.9" fill="currentColor" />
  </svg>
);
